const css = `.zz8Qtq__hoverZone{width:100%;height:100%;z-index:1;position:relative}.zz8Qtq__transitionContainer{pointer-events:none;transition:transform .15s cubic-bezier(.3,1,.32,1);position:absolute}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"hoverZone":"zz8Qtq__hoverZone","transitionContainer":"zz8Qtq__transitionContainer"};
